var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6597 13.9907V12.6583C10.6597 11.9515 10.3789 11.2737 9.87914 10.7739C9.37937 10.2741 8.70155 9.99338 7.99477 9.99338H3.99742C3.29064 9.99338 2.61282 10.2741 2.11305 10.7739C1.61329 11.2737 1.33252 11.9515 1.33252 12.6583V13.9907",
    stroke: "#D1D5DC",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99595 7.32847C7.46774 7.32847 8.66085 6.13536 8.66085 4.66357C8.66085 3.19179 7.46774 1.99867 5.99595 1.99867C4.52417 1.99867 3.33105 3.19179 3.33105 4.66357C3.33105 6.13536 4.52417 7.32847 5.99595 7.32847Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6569 13.9907V12.6583C14.6564 12.0678 14.4599 11.4942 14.0982 11.0276C13.7364 10.5609 13.2299 10.2276 12.6582 10.08",
    stroke: "#D1D5DC",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6597 2.08528C11.2329 2.23205 11.741 2.56543 12.1038 3.03286C12.4666 3.50029 12.6636 4.07518 12.6636 4.6669C12.6636 5.25862 12.4666 5.83352 12.1038 6.30095C11.741 6.76838 11.2329 7.10176 10.6597 7.24853",
    stroke: "#D1D5DC",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUser);
export default __webpack_public_path__ + "static/media/admin-user.b07702fe03f71356a5396a95e6bfe452.svg";
export { ForwardRef as ReactComponent };